import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Anatomy from "../../Docs/Components/Panel/PanelAnatomy.mdx";
import Usage from "../../Docs/Components/Panel/PanelUsage.mdx";

import Examples from "../../Docs/Components/Panel/PanelExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Panel"
            description="Panels are used to provide complex options to the user while maintaining the origin view within easy reach."
            apiSources={["azure-devops-ui/Components/Panel/Panel.Props.d.ts"]}
            examples={Examples}
            internalLinks={{"figma":"https://www.figma.com/file/gSvWotYt9mjikFsbwfFNxyiH/Side-sheets-Modals-Draft?node-id=0%3A1"}}
            status={{"design":"done","code":"done","docs":"done"}}
            anatomy={Anatomy}
            usage={Usage}
        />
    );
}
}
        
export default Page;